import type { BusinessAdmin } from "types";
import requestWithAuth from "../httpClient";
import { rootURL } from "../rootURL";

const businessAdminsURL = `${rootURL}business-admins`;

export function getBusinessAdmins({ searchQuery = "" }) {
	let queryParams = "";
	if (searchQuery) {
		queryParams += `${queryParams ? "&" : "?"}searchQuery=${encodeURIComponent(
			searchQuery,
		)}`;
	}
	return requestWithAuth<BusinessAdmin[]>(
		"get",
		`${businessAdminsURL}/get${queryParams}`,
	);
}

export function submitBusinessAdmin(businessAdminData: BusinessAdmin) {
	return requestWithAuth("post", businessAdminsURL).send(businessAdminData);
}

export function deleteBusinessAdmin(adminId: string) {
	return requestWithAuth("delete", `${businessAdminsURL}/${adminId}`);
}
